
const config  = {
    env: 'uat',
    isSlackBotEnable: true,
    apiURL: window._env_.API_URL,
    documentURL: window._env_.DOCVAULT_URL,
    mapKey: 'AIzaSyC9MY8G6wuzz1lgXDq2Ugjw9jlbw6am78w',
    create_form_status: window._env_.CREATE_FORM_STATUS
};

const CONFIG = config;

export default CONFIG; 